import {ProductCalculationWithAssociations} from '../../Entities/ProductCalculationWithAssociations'
import {MessageWithTranslation} from '../../Entities/MessageWithTranslation.entity.evolve'
import {HttpError} from '../../Data/Http'
import {Pagination} from '../../Data/Pagination'

export interface ProductCalculationOverviewState {
    readonly content: Pagination<ProductCalculationWithAssociations>
    readonly filterOpen: boolean
    readonly searchValue: string
    readonly exactFilter: boolean
    readonly setAttribute: string
    readonly filterSuggestions: MessageWithTranslation[]
    readonly filter: ProductCalculationOverviewFilterList
    readonly error: HttpError | null
}

export interface ProductCalculationOverviewFilterList {
    readonly type: ProductCalculationOverviewFilter
    readonly format: ProductCalculationOverviewFilter
    readonly coverage: ProductCalculationOverviewFilter
    readonly print: ProductCalculationOverviewFilter
    readonly paper: ProductCalculationOverviewFilter
    readonly processing: ProductCalculationOverviewFilter
}

export interface ProductCalculationOverviewFilter {
    readonly value: null | string
    readonly exact: boolean
}

export function initProductCalculationOverviewFilterList(): ProductCalculationOverviewFilterList {
    return {
        type: initProductCalculationOverviewBlankFilter(),
        format: initProductCalculationOverviewBlankFilter(),
        coverage: initProductCalculationOverviewBlankFilter(),
        print: initProductCalculationOverviewBlankFilter(),
        paper: initProductCalculationOverviewBlankFilter(),
        processing: initProductCalculationOverviewBlankFilter(),
    }
}

export function initProductCalculationOverviewBlankFilter(): ProductCalculationOverviewFilter {
    return {
        value: null,
        exact: false
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/ProductCalculationOverview/ProductCalculationOverviewState.ts